import { render } from "./KlaverjasGame.vue?vue&type=template&id=47b74934&scoped=true"
import script from "./KlaverjasGame.vue?vue&type=script&lang=js"
export * from "./KlaverjasGame.vue?vue&type=script&lang=js"

import "./KlaverjasGame.vue?vue&type=style&index=0&id=47b74934&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b74934"]])

export default __exports__